// =============================================================================
//  Copyright : 2018-2024 semantics GmbH
//  Date      : $Date: 2025-03-12 19:26:05 +0100 (Wed, 12 Mar 2025) $
//  Author    : Tobias Schwarzkopf, Dirk Rothe, Andreas Hesse
//  Worker    : $Author: a.hesse $
//  Revision  : $Rev: 150905 $
//  Purpose   : Views for Analytics
// =============================================================================

import {dict, filterItems} from 'ldash'
import {treeAspect, jobTab} from 'uix/views/utils'

const customizeRouting = (nextRequest, nextQuery, oldRequest) => {
  let {classname, query: oldQuery} = oldRequest
  let {classname: next_classname} = nextRequest

  if (classname == 'analytics' && next_classname == 'analytics') {
    let {endDate, rule, startDate} = oldQuery
    let preserved = dict(filterItems({endDate, rule, startDate}, (name, value) => value))
    return {query: {...preserved, ...nextQuery}}
  }
}

const ACTIVE_DT = new Set([0, 1, 2, 3, 10, 14, 21])
const analyticsEnabled = ({datatype, treeNode}) =>
  ACTIVE_DT.has(datatype) || ['domain:all', 'domain:deliverer'].includes(treeNode.nodeType)

export const analytics = {
  ...treeAspect,
  tabGroup: 'analytics',
  acl: 'g:analytics',
  customizeRouting,
  cfg: ({dconfig}) => dconfig.session.statistic.on,
  tabs: {
    overview: {
      tabGroupDefault: true,
      default: true,
      enabled: analyticsEnabled,
      parts: ['AnalyticsOverview'],
      minorTabGroup: 'start',
    },
    usage: {
      enabled: analyticsEnabled,
      parts: ['AnalyticsUsage'],
      minorTabGroup: 'start',
    },
    visitors: {
      enabled: analyticsEnabled,
      parts: ['AnalyticsVisitors'],
      minorTabGroup: 'start',
    },
    job: jobTab({
      names: 'access,session',
      jobButton: [
        'AccessStatsJob',
        'AnalyzeSessionHistoryJob',
        'PurgeSessionData',
        'ResolveUseragents',
      ],
    }),
    sessiondb: {
      datatype: [10],
      parts: ['SessionDbExplorer'],
    },
    useragentsoverview: {
      datatype: [10],
      parts: ['UserAgentsOverview'],
      minorTabGroup: 'useragents',
      icon: 'browser',
    },
    useragentsmanual: {
      datatype: [10],
      parts: ['UserAgentsManual'],
      minorTabGroup: 'useragents',
      icon: 'hand paper outline',
    },
  },
}
